const ErrorUtil = {
    pushErrorToTeliaRum(error) {
        this.supplementErrorStack(error);
        if (window.TeliaRum) {
            window.TeliaRum.sendError(error);
        }
    },
    supplementErrorStack(error) {
        var _a, _b, _c;
        if (error === null || error === void 0 ? void 0 : error.config) {
            const e = error;
            error.stack = `${e === null || e === void 0 ? void 0 : e.message}, ${(_a = e === null || e === void 0 ? void 0 : e.config) === null || _a === void 0 ? void 0 : _a.method}:${(_b = e === null || e === void 0 ? void 0 : e.config) === null || _b === void 0 ? void 0 : _b.url} ${((_c = e === null || e === void 0 ? void 0 : e.response) === null || _c === void 0 ? void 0 : _c.status) || ''} \n ${e.stack}`;
        }
    },
};
export default ErrorUtil;
//# sourceMappingURL=ErrorUtil.js.map